import React, { useState, useEffect } from "react";
import Header from "../Components/Layouts/Header";
import HeroImg from "../Components/Layouts/HeroImg";
import { useCart } from "../context/CartContext";
import { useSearch } from "../context/SearchContext";
import "./MedicineDetail.scss";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import axios from "axios";
import { FaPen, FaTrash } from "react-icons/fa";
import AddMedicineForm from "../Components/Admin/AddMedicine";
import UpdateMedicineForm from "../Components/Admin/UpdateMedicine";
import SentimentResult from "../Components/Other/Sentiment";


const Medicines = () => {
  const { addToCart } = useCart();
  const { searchResult } = useSearch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMedicine, setSelectedMedicine] = useState(null);
  const [medicines, setMedicines] = useState([]);
  const [visibleCount, setVisibleCount] = useState(6);
  const [quantity, setQuantity] = useState(1);
  const [prescriptionDetails, setPrescriptionDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [isMore, setIsMore] = useState(5);
  const { user,authloading } = useAuth();
  const { cart } = useCart();

  // Filters
  const [sortOrder, setSortOrder] = useState("default");
  const [categoryFilter, setCategoryFilter] = useState("All");
  const [minRating, setMinRating] = useState(0);
  const [name, setName] = useState("");


// Admin Functionality

const deleteMedicine = async (medicineId) => {
  try {
    const { data } = await axios.delete(`/medicines/${medicineId}`, {
      withCredentials: true,
    });

    console.log("Medicine deleted:", data);
    setMedicines((prevMedicines) =>
      prevMedicines.filter((medicine) => medicine._id !== medicineId)
    );
    fetchMedicines(); 
    toast.success("Medicine deleted successfully!");
  } catch (error) {
    console.error("Error deleting medicine:", error.response?.data?.error || error.message);
    toast.error("Failed to delete medicine. Please try again.");
    if (error.response?.data?.error) {
      toast.error(error.response.data.error);
    }
  }
};

// Admin Functionality End

  const calculateAverageRating = (reviews) => {
    if (!reviews || reviews.length === 0) return 0;

    const total = reviews.reduce((sum, review) => sum + review.rating, 0);
    return (total / reviews.length).toFixed(1); 
  };

  const fetchMedicines = async () => {
    if (searchResult && searchResult.length > 0) return;
    setLoading(true);
    try {
      const response = await fetch("/medicines", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });
      const data = await response.json();
      if (response.ok) setMedicines(data);
      else console.error("Error fetching medicines:", data.message);
    } catch (error) {
      console.error("Error fetching medicines:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!authloading && (!searchResult || searchResult.length === 0)) {
      fetchMedicines();
    }
  }, [authloading, searchResult]);
  
 
  const filteredMedicines = (() => {
    let meds =
      searchResult && (Array.isArray(searchResult) ? searchResult.length : true)
        ? Array.isArray(searchResult)
          ? searchResult
          : [searchResult]
        : medicines;

    if (categoryFilter !== "All") {
      meds = meds.filter((m) => m.category === categoryFilter);
    }

    if (minRating > 0) {
      meds = meds.filter((m) => calculateAverageRating(m.reviews) >= minRating);
    }

    if (sortOrder === "price-asc") {
      meds = [...meds].sort((a, b) => a.price - b.price);
    } else if (sortOrder === "price-desc") {
      meds = [...meds].sort((a, b) => b.price - a.price);
    }

    if (name) {
      meds = meds.filter((m) =>
        m.name.toLowerCase().includes(name.toLowerCase())
      );
    }

    return meds;
  })();

  const uniqueCategories = [...new Set(medicines.map((m) => m.category))];

  const handleAddToCart = async ({setLoading, showToast}) => {
    if (quantity < 1) return toast.warning("Please enter a valid quantity.");

    const currentTotal = cart.reduce((acc, item) => acc + item.quantity, 0);
  if (currentTotal + quantity > 10) {
    return showToast?.("You can't have more than 10 items in cart!", { type: "warning" });
  }

    let prescriptionData = null;
    if (selectedMedicine.prescription) {
      if (!prescriptionDetails.doctorName?.trim())
        return toast.warning("Doctor's name is required for prescription medicines.");
      prescriptionData = { ...prescriptionDetails };
    }

    await addToCart(selectedMedicine._id, quantity, prescriptionData ,{setLoading, showToast});
    setIsModalOpen(false);
    setQuantity(1);
    setPrescriptionDetails({});
  };

  const [showEditForm, setShowEditForm] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const UpdateMedicine = async (updatedMedicine) => {
    fetchMedicines();
    setMedicines((prevMedicines) =>
      prevMedicines.map((medicine) =>
        medicine._id === updatedMedicine._id ? updatedMedicine : medicine
      )
    );
  
    setShowEditForm(null);
  };
  

  return (
    <>
      <Header />
      <HeroImg heading="Medicines" text="Our Services / Medicines" />

      {/* Filter Section */}
      <div className="filters">
        <select
          onChange={(e) => setSortOrder(e.target.value)}
          value={sortOrder}
        >
          <option value="default">Sort By</option>
          <option value="price-asc">Price: Low to High</option>
          <option value="price-desc">Price: High to Low</option>
        </select>

        <select
          onChange={(e) => setCategoryFilter(e.target.value)}
          value={categoryFilter}
        >
          <option value="All">All Categories</option>
          {uniqueCategories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>

        <div className="rating-filter">
          <label>Min Rating: {minRating}★</label>
          <input
            type="range"
            min="0"
            max="5"
            step="0.5"
            value={minRating}
            onChange={(e) => setMinRating(parseFloat(e.target.value))}
          />
        </div>

          {user && user.role==="admin" && <div>
        <input type="text" placeholder="Search by medicine name" value={name} onChange={(e) => setName(e.target.value)} />
        </div>}
        

        <button className="reset-filters" onClick={() => {setCategoryFilter("All") ; setSortOrder("default"); setMinRating(0); setVisibleCount(6); setName("")}}>
          Reset Filters
        </button>

        {user && user.role==="admin" && <button className="Add" onClick={()=>setShowAddForm(!showAddForm)}>Add Medicine</button>}
        {showAddForm && <AddMedicineForm closeModal={()=>setShowAddForm(false)} onMedicineAdded={fetchMedicines}/>}
      </div>

      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : filteredMedicines.length > 0 ? (
        <>
        <div className="medicines-grid">
          {filteredMedicines.slice(0, visibleCount).map((medicine) => (
            <div key={medicine._id} className="medicine-card">
               {user && user.role==="admin" && <div className="admin-controls"><FaTrash onClick={()=>deleteMedicine(medicine._id)}/><FaPen onClick={()=> setShowEditForm((prevId) => (prevId === medicine._id ? null : medicine._id))}/></div>}
              {showEditForm === medicine._id && (
                <UpdateMedicineForm
                  medicineId={medicine._id}
                  closeModal={() => setShowEditForm(null)}
                  onMedicineUpdated={UpdateMedicine}
                />
              )}
              <div className="rx">
                {medicine.prescription && (
                  <img src="./rx.png" alt="Rx" />
                )}
              </div>
              <img
                className="medicine-image"
                src={`data:image/png;base64,${medicine.image}`} alt={medicine.name}
              />
              <h2>{medicine.name}</h2>
              <p>
                <strong>Category:</strong> {medicine.category}
              </p>
              <p className="price">₹{medicine.price}</p>
              <p className="rating">
                <div className="star-rating">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span key={star}>
                      {star <=
                      Math.round(calculateAverageRating(medicine.reviews))
                        ? "⭐"
                        : "☆"}
                    </span>
                  ))}
                </div>{" "}
                ({medicine.reviews?.length || 0} reviews)
              </p>
              <span>
                {medicine.stock ? (
                  <p style={{ color: "Green" }}>In Stock</p>
                ) : (
                  <p style={{ color: "Red" }}>Out of Stock</p>
                )}
              </span>
              <button
                className="view-details"
                onClick={() => {
                  setSelectedMedicine(medicine);
                  setIsModalOpen(true);
                }}
              >
                View Details
              </button>
            </div>
          ))}
        </div>
           {filteredMedicines.length > visibleCount && (
            <div className="see-more-container">
              <button
                className="see-more"
                onClick={() => setVisibleCount((prev) => prev + 6)}
              >
                See More
              </button>
            </div>
          )}
          </>
      ) : (
        <div className="empty">
          <img src="./medicinenf.png" alt="empty medicine" />
          <h3>Medicine not found!!</h3>
          {!user && (
            <div>
              {" "}
              <h3>Have an account?</h3>
              <p style={{ marginTop: "10px" }}>
                <a href="/login">Login</a> to check out faster!!
              </p>
            </div>
          )}
        </div>
      )}
      {/* Modal */}
      {isModalOpen && selectedMedicine && (
        <div
          className="modal-overlay active"
          onClick={() => setIsModalOpen(false)}
        >
          <div
            className="service-modal active"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <span
                className="close-modal"
                onClick={() => setIsModalOpen(false)}
              >
                &times;
              </span>
              <img
                src={`data:image/png;base64,${selectedMedicine.image}`}
                alt={selectedMedicine.name}
              />
              <h2>{selectedMedicine.name}</h2>
              <p>
                <strong>Category:</strong> {selectedMedicine.category}
              </p>
              <p>
                <strong>Description:</strong> {selectedMedicine.description}
              </p>
              <p className="price">₹{selectedMedicine.price}</p>
              <div className="reviews">
                <h3>Reviews</h3>
                <ul className="reviews">
                  <SentimentResult reviews={selectedMedicine.reviews || []} />
                  {selectedMedicine.reviews?.length > 0 ? (
                    selectedMedicine.reviews
                      .slice(0, isMore)
                      .map((review) => (
                        <li key={review._id}>
                          <div className="user-info">
                         <strong>{review.user?.name || "Anonymous"} </strong>
                          <p>
                            {new Date(review.createdAt).toLocaleDateString()}
                          </p>
                          </div>
                          
                          <div className="rating-info">
                          <div className="star-rating">
                            {[1, 2, 3, 4, 5].map((star) => (
                              <span key={star}>
                                {star <= review.rating ? "⭐" : "☆"}
                              </span>
                            ))}
                          </div>
                          {review.comment}
                          </div>
                        </li>
                      ))
                  ) : (
                    <p>No reviews yet.</p>
                  )}

                  {selectedMedicine.reviews?.length > visibleCount && (
                    <button
                      className="see-more"
                      onClick={() => setIsMore((prev) => prev + 6)}
                    >
                      See More
                    </button>
                  )}
                </ul>
              </div>

              <div className="quantity-section">
                <label>Quantity:</label>
                <input
                  type="number"
                  min="1"
                  value={quantity}
                  onChange={(e) => setQuantity(Number(e.target.value))}
                />
              </div>

              {selectedMedicine.prescription && (
                <div className="prescription-form">
                  <h3>Prescription Details</h3>
                  <label>Doctor's Name:</label>
                  <input
                    type="text"
                    value={prescriptionDetails.doctorName || ""}
                    onChange={(e) =>
                      setPrescriptionDetails({
                        ...prescriptionDetails,
                        doctorName: e.target.value,
                      })
                    }
                    required
                  />
                  <label>Prescription ID (Optional):</label>
                  <input
                    type="text"
                    value={prescriptionDetails.prescriptionId || ""}
                    onChange={(e) =>
                      setPrescriptionDetails({
                        ...prescriptionDetails,
                        prescriptionId: e.target.value,
                      })
                    }
                  />
                  <label>Prescription Note:</label>
                  <textarea
                    value={prescriptionDetails.prescriptionNote || ""}
                    style={{ resize: "vertical", width: "100%" }}
                    onChange={(e) =>
                      setPrescriptionDetails({
                        ...prescriptionDetails,
                        prescriptionNote: e.target.value,
                      })
                    }
                  />
                </div>
              )}

              <button onClick={()=>handleAddToCart({ setLoading, showToast: (msg, opts) => toast(msg, opts) })} className="book-now">
               {loading?("Adding to Cart"):("Add to Cart")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Medicines;
